import { createFileRoute, redirect } from "@tanstack/react-router";
import { sessionQueryKey, type AdminSession } from "@/queries/session";
import { ManagedWorkspacePage } from "@/features/managed-administration/pages/workspace-page";
import { workspaceOptions } from "@/features/managed-administration/queries";
export const Route = createFileRoute("/_authed/managed/")({ beforeLoad: ({ context }) => {
  if (context.queryClient.getQueryData<AdminSession>(sessionQueryKey)?.is_platform_admin) throw redirect({ to: "/tenants", replace: true });
}, loader: ({ context }) => context.queryClient.ensureQueryData(workspaceOptions()), component: ManagedWorkspacePage });
